<ng-container *ngIf="hasErrorValue">
    <div class="login-error">
        <strong *ngIf="showLink.length > 1" class="error__title">Password Reset Required</strong>
        <span class="error__body">{{ this.errorMessage }}</span>
        <a class="error__link" *ngIf="showLink.length > 1" href="/login#/reset-password/{{showLink}}">RESET PASSWORD</a>
    </div>
</ng-container>

<ng-container #fieldComponent></ng-container>

<div class="text-wrapper">
    <p class="text__small">
        <a href="/index.php?option=com_mclogin&view=mcforgotpassword" title="forgot password">Forgot Password</a>
    </p>
    <p class="text__small">
        <a href="/index.php?option=com_mclogin&view=mcforgotusername" title="forgot username">Forgot Username</a>
    </p>
</div>

<sl-button class="btn--primary" type="button" [disabled]="formControl.invalid" (click)="onSubmit()">Login</sl-button>